module.exports = __webpack_public_path__ + "media/images/admin/icons/triangle-a3999de48b7f01fc860df3c0fe3e6a5b.svg";